import Notify from 'src/constants/notify';
import i18n from 'src/i18n/index.js';
import isUndefined from 'lodash/isUndefined';

const routeGuard = async (to, from, next, store) => {
  store.dispatch('auth/fetchUser').then(() => {
    const requiresAuthentication = to.matched.some((record) => record.meta.requiresAuth);
    const isAuthorized = to.matched.every(
      (record) => isUndefined(record.meta.isAuthorized) || record.meta.isAuthorized(),
    );

    if (requiresAuthentication) {
      const isAuthenticated = store.getters['user/isLoggedIn'];
      if (isAuthenticated) {
        if (isAuthorized) {
          next();
        } else {
          next({
            name: 'home',
          });

          Notify.create({
            type: 'negative',
            message: i18n.global.t('route-guard.not-allowed'),
            position: 'bottom-right',
          });
        }
      } else if (store.getters['user/label'].collectivityLabel === 'aev') {
        next({
          name: 'splash',
        });
      } else {
        next({
          name: 'login',
          query: {
            redirect: to.fullPath,
          },
          params: { label: to.params.label },
        });
      }
    } else {
      next();
    }
  });
};

export default async ({ router, store }) => {
  router.beforeEach(async (to, from, next) => routeGuard(to, from, next, store));
};

export { routeGuard };
